module.exports = __webpack_public_path__ + "img/title4.8b54a405.png";